import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { currentRouteSet } from '../../actions/actions';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom'
import { pathSpliter, dateTimeFormat, currentDateTime, getDateTimeFromISODT, currentDateStartTime, currentDateEndTime } from '../../lib/functions'
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ReceiptIcon from '@material-ui/icons/Receipt';
import DateFnsUtils from '@date-io/date-fns'; // choose your libs
import { API_URL } from '../../config';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment';
import _ from 'lodash';
import PrintIcon from '@material-ui/icons/Print';
import Select from 'react-select';
import { NetworkLoaderOverlay } from "../commons/NetworkLoader";


import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';
import swal from 'sweetalert';
import InstitutionProfile from '../commons/institution_profile'
import ReactToPrint from "react-to-print";
import commaNumber from 'comma-number';
let format = commaNumber.bindWith(',', '.')

const createCalculatorState = (value = 0) => ({
  openingStock: String(value),
  purchases: String(value),
  closingStock: String(value),
  totalSales: String(value),
  totalExpenses: String(value),
});

const toSafeNumber = (value) => {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const CustomerTransactionHistory = ({ location, currentRoute, currentRouteSet, authInfo }) => {
  const isCalculatorPage = location?.pathname?.includes('/reports/profit-calculator') || location?.search?.includes('calculator=1');
  const getYearRange = (year = moment().year()) => ({
    fromDate: moment().year(Number(year)).startOf('year').toDate(),
    toDate: moment().year(Number(year)).endOf('year').toDate(),
  });
  const classes = useStyles();
  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
  }, []);
  let [customers, customersSet] = useState([]);
  let [selectedCustomer, selectedCustomerSet] = useState(null);
  let [report, reportSet] = useState([]);
  let [othersReport, othersReportSet] = useState(null);
  let [print, printSet] = useState(false);
  let [reportLoading, reportLoadingSet] = useState(false);

  let [totalSoldAmount, totalSoldAmountSet] = useState(0);
  let [totalPurchaseAmount, totalPurchaseAmountSet] = useState(0);
  let [totalSaleProfitLoss, totalSaleProfitLossSet] = useState(0);
  let [totalSaleDiscount, totalSaleDiscountSet] = useState(0);

  let [products, productsSet] = useState([]);
  let [selectedProduct, selectedProductSet] = useState(null);
  let [productWiseProfit, productWiseProfitSet] = useState([]);
  let [productProfit, productProfitSet] = useState(0);
  let [calculatorLoading, calculatorLoadingSet] = useState(false);
  let [calculatorValues, calculatorValuesSet] = useState(createCalculatorState());
  let [calculatorSource, calculatorSourceSet] = useState('');
  let [calculatorError, calculatorErrorSet] = useState('');
  let [selectedCalculatorYear, selectedCalculatorYearSet] = useState(String(moment().year()));





  let [byDateTime, byDateTimeSet] = useState(isCalculatorPage ? getYearRange(moment().year()) : {
    fromDate: currentDateStartTime(),
    toDate: currentDateEndTime()
  })

  let customerRef = useRef(null);
  let fromDateRef = useRef(null);
  let reportRef = useRef(null);


  let [types, typesSet] = useState([{ label: 'All', value: 'all' }, { label: 'Customer Wise', value: 'customer' },
  { label: 'Product Wise', value: 'product' }, { label: 'Product Wise Summary', value: 'product_summary' }]);
  let [selectedType, selectedTypeSet] = useState({ label: 'All', value: 'all' });

  useEffect(() => {
    getCusomers();
    getProducts()
  }, []);

  useEffect(() => {
    if (isCalculatorPage) {
      const yearRange = getYearRange(selectedCalculatorYear);
      byDateTimeSet(yearRange);
      loadCalculatorData(yearRange);
    }
  }, [isCalculatorPage, selectedCalculatorYear]);

  const getCalculatorResult = (values) => {
    const openingStock = toSafeNumber(values.openingStock);
    const purchases = toSafeNumber(values.purchases);
    const closingStock = toSafeNumber(values.closingStock);
    const totalSales = toSafeNumber(values.totalSales);
    const totalExpenses = toSafeNumber(values.totalExpenses);
    const cogs = openingStock + purchases - closingStock;
    const profit = totalSales - cogs - totalExpenses;
    const status = profit > 0 ? 'Profit' : profit < 0 ? 'Loss' : 'Break Even';

    return { openingStock, purchases, closingStock, totalSales, totalExpenses, cogs, profit, status };
  };

  const exportCalculatorCsv = (values) => {
    const result = getCalculatorResult(values);
    const rows = [
      ['Field', 'Amount'],
      ['Opening Stock', result.openingStock],
      ['Purchases', result.purchases],
      ['Closing Stock', result.closingStock],
      ['Total Sales', result.totalSales],
      ['Total Expenses', result.totalExpenses],
      ['COGS', result.cogs],
      ['Profit', result.profit],
      ['Status', result.status],
    ];

    const csv = rows
      .map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(','))
      .join('\n');

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.setAttribute('download', `profit-calculator-${moment().format('YYYY-MM-DD-HH-mm')}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const loadCalculatorData = async (range = byDateTime) => {
    const payload = {
      fromDate: range.fromDate,
      toDate: range.toDate,
      customerId: selectedCustomer != null ? selectedCustomer.customer_id : null,
      prodId: selectedProduct != null ? selectedProduct.prod_id : null,
    };

    calculatorLoadingSet(true);
    calculatorErrorSet('');

    const headers = { headers: { 'auth-token': authInfo.token } };

    try {
      const [
        salesRes,
        purchasesRes,
        openingStockRes,
        closingStockRes,
        othersRes,
      ] = await Promise.allSettled([
        axios.post(`${API_URL}/api/get-sales`, {
          reqPayload: payload,
        }, headers),
        axios.post(`${API_URL}/api/get-purchase`, {
          reqPayload: payload,
        }, headers),
        axios.post(`${API_URL}/api/opening-stock-summary`, {
          action: 'list',
          search: '',
          page: 1,
          perPage: 10000,
          recentProductIds: [],
        }, headers),
        axios.post(`${API_URL}/api/get-product-current-stock-detail`, {
          ...payload,
        }, headers),
        axios.post(`${API_URL}/api/get-others-profit-loss`, {
          ...payload,
        }, headers),
      ]);

      const salesRows = Array.isArray(salesRes?.value?.data?.message) ? salesRes.value.data.message : [];
      const purchaseRows = Array.isArray(purchasesRes?.value?.data?.message) ? purchasesRes.value.data.message : [];
      const openingStockRows = Array.isArray(openingStockRes?.value?.data?.data) ? openingStockRes.value.data.data : [];
      const closingStockRows = Array.isArray(closingStockRes?.value?.data) ? closingStockRes.value.data : [];
      const othersReportData = othersRes?.value?.data || null;

      const totalSales = _.sumBy(salesRows, (row) => toSafeNumber(row.sale_total_amount ?? row.sale_prod_total ?? 0));
      const purchases = _.sumBy(purchaseRows, (row) => toSafeNumber(row.pur_total_amount ?? row.purchase_total ?? 0));
      const openingStock = _.sumBy(openingStockRows, (row) => toSafeNumber(row.stock_value ?? (toSafeNumber(row.opening_quantity) * toSafeNumber(row.prod_purchase_rate)) ?? 0));
      const closingStock = _.sumBy(closingStockRows, (row) => toSafeNumber(row.stock_value ?? 0));
      const salesDiscount = _.sumBy(salesRows, (row) => toSafeNumber(row.sale_discount_amount ?? 0));
      const totalExpenses = [
        othersReportData?.cashTranLoss,
        othersReportData?.serviceExpenseAmount,
        othersReportData?.employeeSalaryPay,
        othersReportData?.productDamageAmount,
        othersReportData?.materialDamageAmount,
        othersReportData?.salesReturnAmount,
        salesDiscount,
      ].reduce((sum, item) => sum + toSafeNumber(item), 0);

      const nextState = createCalculatorState();
      nextState.openingStock = String(openingStock);
      nextState.purchases = String(purchases);
      nextState.closingStock = String(closingStock);
      nextState.totalSales = String(totalSales);
      nextState.totalExpenses = String(totalExpenses);

      calculatorValuesSet(nextState);
      calculatorSourceSet('Backend data loaded for the selected date range.');

      if (
        salesRes.status === 'rejected' ||
        purchasesRes.status === 'rejected' ||
        openingStockRes.status === 'rejected' ||
        closingStockRes.status === 'rejected' ||
        othersRes.status === 'rejected'
      ) {
        calculatorSourceSet('Some backend values were unavailable, so missing values were treated as 0.');
      }
    } catch (error) {
      calculatorErrorSet(error?.response?.data?.message || 'Could not load calculator data from backend.');
      calculatorSourceSet('');
    } finally {
      calculatorLoadingSet(false);
    }
  };

  const renderCalculatorPage = () => {
    const result = getCalculatorResult(calculatorValues);
    const profitBg = result.profit < 0 ? '#fde9ec' : '#e3f3ef';
    const resultBg = '#eef6f5';
    const yearOptions = Array.from({ length: 8 }, (_, index) => {
      const year = moment().year() - index;
      return { label: String(year), value: String(year) };
    });

    return (
      <div style={{ padding: '12px' }}>
        <Paper style={{ overflow: 'hidden' }}>
          <div style={{ background: '#0F7E77', color: '#fff', padding: '10px 14px', fontSize: '22px', fontWeight: 700 }}>
            Profit Calculator (লাভ হিসাব পত্র)
          </div>
          <div style={{ padding: '10px 14px', borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px', alignItems: 'center' }}>
            <div>
              Yearly statement
              <br />
              {moment(byDateTime.fromDate).format('DD MMM YYYY')} to {moment(byDateTime.toDate).format('DD MMM YYYY')}
            </div>
            <div style={{ minWidth: 160 }}>
              <Select
                value={yearOptions.find((option) => option.value === String(selectedCalculatorYear))}
                onChange={(option) => {
                  if (!option) return;
                  selectedCalculatorYearSet(option.value);
                }}
                options={yearOptions}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: 42,
                    borderColor: '#0F7E77',
                    boxShadow: 'none',
                    '&:hover': { borderColor: '#0F7E77' },
                  }),
                  singleValue: (base) => ({ ...base, color: '#0F7E77', fontWeight: 700 }),
                  placeholder: (base) => ({ ...base, color: '#0F7E77' }),
                }}
              />
            </div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              <Button
                onClick={() => loadCalculatorData(getYearRange(selectedCalculatorYear))}
                variant="outlined"
                style={{ borderColor: '#0F7E77', color: '#0F7E77' }}
                disabled={calculatorLoading}
              >
                Reload
              </Button>
              <Button
                onClick={() => exportCalculatorCsv(calculatorValues)}
                variant="outlined"
                style={{ borderColor: '#007CA9', color: '#007CA9' }}
                disabled={calculatorLoading}
              >
                Export CSV
              </Button>
              <Button
                component={Link}
                to="/reports/profit-loss"
                variant="contained"
                style={{ background: '#0F7E77', color: '#fff' }}
              >
                Back to Report
              </Button>
            </div>
          </div>

          {calculatorLoading ? (
            <div style={{ padding: '26px 14px', textAlign: 'center' }}>Loading backend values...</div>
          ) : (
            <>
              {calculatorError ? (
                <div style={{ margin: '12px 14px 0', padding: '10px 12px', background: '#fff2f2', color: '#b30000', border: '1px solid #f1c4c4' }}>
                  {calculatorError}
                </div>
              ) : null}
              {calculatorSource ? (
                <div style={{ margin: '12px 14px 0', padding: '10px 12px', background: '#eef8ff', border: '1px solid #cde8ff' }}>
                  {calculatorSource}
                </div>
              ) : null}

              <TableContainer style={{ padding: '14px' }}>
                <Table size="small" aria-label="profit calculator table">
                  <TableBody>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700, fontSize: '18px', background: '#0F7E77', color: '#fff' }} colSpan={2}>
                        Profit Calculator (লাভ হিসাব পত্র)
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>Opening Stock (বছরের শুরুতে স্টক):</TableCell>
                      <TableCell style={{ background: '#fff8e9', textAlign: 'right', fontSize: '18px', fontWeight: 700 }}>{format(result.openingStock.toFixed(2))}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>Purchases (বছরে কেনা মাল):</TableCell>
                      <TableCell style={{ background: '#fff8e9', textAlign: 'right', fontSize: '18px', fontWeight: 700 }}>{format(result.purchases.toFixed(2))}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>Closing Stock (বছরের শেষ স্টক):</TableCell>
                      <TableCell style={{ background: '#fff8e9', textAlign: 'right', fontSize: '18px', fontWeight: 700 }}>{format(result.closingStock.toFixed(2))}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>Total Sales (মোট বিক্রি):</TableCell>
                      <TableCell style={{ background: '#fff8e9', textAlign: 'right', fontSize: '18px', fontWeight: 700 }}>{format(result.totalSales.toFixed(2))}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>Total Expenses (অন্যান্য খরচ):</TableCell>
                      <TableCell style={{ background: '#fff8e9', textAlign: 'right', fontSize: '18px', fontWeight: 700 }}>{format(result.totalExpenses.toFixed(2))}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={2} style={{ background: '#ffffff', height: 16 }} />
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>COGS = Opening + Purchases - Closing:</TableCell>
                      <TableCell style={{ background: resultBg, textAlign: 'right', fontSize: '18px', fontWeight: 700 }}>{format(result.cogs.toFixed(2))}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>Profit = Sales - COGS - Expenses:</TableCell>
                      <TableCell style={{ background: profitBg, textAlign: 'right', fontSize: '18px', fontWeight: 700, color: result.profit < 0 ? '#b42318' : '#0F7E77' }}>
                        {format(result.profit.toFixed(2))}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>Status:</TableCell>
                      <TableCell style={{ background: resultBg, textAlign: 'right', fontSize: '18px', fontWeight: 700, color: '#0F7E77' }}>
                        {result.status}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={2} style={{ background: '#0F7E77', color: '#fff', fontWeight: 700 }}>
                        Notes
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={2}>
                        Opening Stock, Purchases, Closing Stock, Sales and Expenses are loaded from backend and shown read-only.
                        The page auto-calculates the selected year statement.
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
        </Paper>
      </div>
    );
  };

  let getProducts = async () => {
    await axios.post(`${API_URL}/api/get-individual-products`, { 'select-type': 'active' }, { headers: { 'auth-token': authInfo.token } }).then(res => [
      productsSet(res.data.message)
    ]);
  }



  let getCusomers = async () => {
    await axios.post(`${API_URL}/api/get-customers`, { 'select-type': 'active' }, { headers: { 'auth-token': authInfo.token } }).then(res => {
      customersSet(res.data.message)
    })
  }




  let getSearchResult = async () => {



    let payload = {
      customerId: selectedCustomer != null ? selectedCustomer.customer_id : null,
      prodId: selectedProduct != null ? selectedProduct.prod_id : null,
      fromDate: byDateTime.fromDate,
      toDate: byDateTime.toDate
    }


    if (selectedType.value != 'product_summary') {


      await axios.post(`${API_URL}/api/get-sales-profit-loss`, { ...payload }, { headers: { 'auth-token': authInfo.token } }).then(res => {
        reportSet(res.data)

        let soldAmount = _.sumBy(res.data, ({ details }) => _.sumBy(details, 'sale_prod_total'));
        totalSoldAmountSet(soldAmount);

        let purchaseAmount = _.sumBy(res.data, ({ details }) => _.sumBy(details, 'purchasedAmount'));
        totalPurchaseAmountSet(purchaseAmount);

        let prodProfitLoss = _.sumBy(res.data, ({ details }) => _.sumBy(details, 'productProfitLoss'));
        totalSaleProfitLossSet(prodProfitLoss);

        let discount = _.sumBy(res.data, 'sale_discount_amount');
        totalSaleDiscountSet(discount);




        printSet(true)
      });

    } else {
      await axios.post(`${API_URL}/api/get-product-profit-loss`, { ...payload }, { headers: { 'auth-token': authInfo.token } }).then(res => {
        productWiseProfitSet(res.data)

        let prodProfitAmount = res.data.reduce((prev, curr) => {
          return prev + parseFloat(curr.prod_profit_amount)
        }, 0);

        productProfitSet(prodProfitAmount)

      })
      printSet(true)

    }

    reportLoadingSet(true)
    await axios.post(`${API_URL}/api/get-others-profit-loss`, { ...payload }, { headers: { 'auth-token': authInfo.token } }).then(res => {
      othersReportSet(res.data)
      reportLoadingSet(false)
    })

  }


  let ReportDom = React.forwardRef((props, ref) => {
    return (<div ref={ref}>
      <InstitutionProfile />

      <div style={{ clear: 'both' }}></div>
      <Paper style={{ width: '100%', paddingLeft: '10px', paddingRight: '10px' }} className="print-source">
        <p style={{ width: '100%', textAlign: 'center', fontWeight: 'bold' }}>Profit  Loss Report</p>

        <p style={{ float: 'left', width: '30%', textAlign: 'left', margin: 0, padding: 0, fontSize: '16px' }}>
          {selectedCustomer != null ? `Customer : ${selectedCustomer != null ? selectedCustomer.customer_name : ''}` : ''}
        </p>

        <p style={{ float: 'right', width: '40%', textAlign: 'right', margin: 0, padding: 0 }}> Statement From {moment(byDateTime.dateTimeFrom).format(dateTimeFormat)} <br /> TO {moment(byDateTime.dateTimeTo).format(dateTimeFormat)}
        </p>
      </Paper>


      {

        selectedType.value != 'product_summary' ? (

          report.length > 0 ? (
            <Paper className={classes.paper} style={{ marginTop: '8px', marginBottom: '5px' }} >


              <TableContainer >
                <Table className={classes.table} size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left" style={{ width: '1%' }}> Code</TableCell>
                      <TableCell align="right" style={{ width: '10%' }}>Product Name</TableCell>
                      <TableCell align="right" style={{ width: '15%' }}>Sold Rate</TableCell>
                      <TableCell align="right" style={{ width: '15%' }}>Sold Quantity</TableCell>
                      <TableCell align="right" style={{ width: '15%' }}>Sold </TableCell>
                      <TableCell align="right" style={{ width: '15%' }}>Purchase Rate</TableCell>
                      <TableCell align="right" style={{ width: '15%' }}>Purchased</TableCell>
                      <TableCell align="right" style={{ width: '15%' }}>Product Profit/Loss</TableCell>

                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      report.map((sale, index) => (
                        <>
                          <TableRow key={index}>
                            <TableCell colSpan={8}>
                              Sales Invoice No : {sale.sale_invoice} |
                              Sales Date & Time : {moment(sale.sale_created_isodt).format('DD MMM Y h:m a')} |
                              Customer Name : {sale.customer_name} |
                              Customer Code : {sale.customer_code} |
                              Discount : {sale.sale_discount_amount}

                            </TableCell>
                          </TableRow>

                          {
                            sale.details.map((product, sl) => (
                              <TableRow key={sl}>

                                <TableCell align="left">{product.prod_code}</TableCell>
                                <TableCell align="right">{product.prod_name}</TableCell>
                                <TableCell align="right">{product.sale_rate}</TableCell>
                                <TableCell align="right">{product.sale_qty} {product.prod_unit_name}</TableCell>
                                <TableCell align="right">{format(parseFloat(product.sale_prod_total).toFixed(2))}</TableCell>
                                <TableCell align="right">{format(parseFloat(product.sale_prod_purchase_rate).toFixed(2))}</TableCell>
                                <TableCell align="right">{format(parseFloat(product.purchasedAmount).toFixed(2))}</TableCell>
                                <TableCell align="right">{format(parseFloat(product.productProfitLoss).toFixed(2))}</TableCell>
                              </TableRow>
                            ))
                          }


                          {
                            <TableRow key={index + 1} style={{ background: '#E3EAE7' }}>
                              <TableCell colSpan={3} style={{ textAlign: 'right' }}>Sub Total : </TableCell>
                              <TableCell align="right" colSpan={2}>   {format(parseFloat(_.sumBy(sale.details, 'sale_prod_total')).toFixed(2))}</TableCell>
                              <TableCell align="right" colSpan={2}> {format(parseFloat(_.sumBy(sale.details, 'purchasedAmount')).toFixed(2))}</TableCell>
                              <TableCell align="right" colSpan={2}> {format(parseFloat(_.sumBy(sale.details, 'productProfitLoss')).toFixed(2))}</TableCell>



                            </TableRow>

                          }

                        </>
                      ))
                    }


                    <TableRow key={0} style={{ background: '#BDD5CA' }}>
                      <TableCell colSpan={3} style={{ textAlign: 'right' }}> Total : </TableCell>
                      <TableCell align="right" colSpan={2}> Total Sold :  {format(parseFloat(totalSoldAmount).toFixed(2))}</TableCell>
                      <TableCell align="right" colSpan={2}> Total Purchased : {format(parseFloat(totalPurchaseAmount).toFixed(2))}</TableCell>
                      <TableCell align="right" colSpan={2}> Total Profit/Loss : {format(parseFloat(totalSaleProfitLoss).toFixed(2))}</TableCell>



                    </TableRow>



                    <TableRow  >
                      <TableCell colSpan={7} align="right">Income from Cash Transaction (+)</TableCell>

                      <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.cashTranProfit).toFixed(2)) : 0}</TableCell>
                    </TableRow>


                    <TableRow  >
                      <TableCell colSpan={7} align="right">Income from Services (+)</TableCell>

                      <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.serviceIncomeAmount).toFixed(2)) : 0}</TableCell>
                    </TableRow>


                    <TableRow>

                      <TableCell colSpan={7} align="right">Expense for Services Item (-)</TableCell>
                      <TableCell align="right"> {othersReport != null ? format(parseFloat(othersReport.serviceExpenseAmount).toFixed(2)) : 0}</TableCell>
                    </TableRow>




                    <TableRow>

                      <TableCell colSpan={7} align="right">Sales Return (-)</TableCell>
                      <TableCell align="right"> {othersReport != null ? format(parseFloat(othersReport.salesReturnAmount).toFixed(2)) : 0}</TableCell>
                    </TableRow>

                    <TableRow  >

                      <TableCell colSpan={7} align="right">Sales Discount (-) </TableCell>
                      <TableCell align="right">{format(parseFloat(totalSaleDiscount).toFixed(2))}</TableCell>

                    </TableRow>
                    <TableRow  >

                      <TableCell colSpan={7} align="right">Product Total Damage (-) </TableCell>
                      <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.productDamageAmount).toFixed(2)) : 0}</TableCell>



                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={7} align="right">Material Total Damage (-) </TableCell>
                      <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.materialDamageAmount).toFixed(2)) : 0}</TableCell>
                    </TableRow>
                    <TableRow  >
                      <TableCell colSpan={7} align="right">Expense (-) </TableCell>
                      <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.cashTranLoss).toFixed(2)) : 0}</TableCell>


                    </TableRow>

                    <TableRow>
                      <TableCell colSpan={7} align="right">Employee Payment (-) </TableCell>
                      <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.employeeSalaryPay).toFixed(2)) : 0}</TableCell>

                    </TableRow>
                    <TableRow  >


                      <TableCell colSpan={7} align="right">Total Profit / Loss   </TableCell>
                      <TableCell align="right">{othersReport != null ? format(parseFloat((totalSaleProfitLoss + parseFloat(othersReport.cashTranProfit) + parseFloat(othersReport.serviceIncomeAmount)) -
                        parseFloat(othersReport.productDamageAmount + parseFloat(othersReport.cashTranLoss) +
                          parseFloat(othersReport.employeeSalaryPay) + parseFloat(totalSaleDiscount) + parseFloat(othersReport.salesReturnAmount) + parseFloat(othersReport.materialDamageAmount) + parseFloat(othersReport.serviceExpenseAmount))).toFixed(2)) : 0}</TableCell>

                    </TableRow>















                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          ) : ''

        ) : (<>


          <Paper className={classes.paper} style={{ marginTop: '8px', marginBottom: '5px' }} >
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Product Name</TableCell>
                    <TableCell>Product Code</TableCell>
                    <TableCell>Sold Qty</TableCell>
                    <TableCell>Sold Amount</TableCell>
                    <TableCell>Purchased Amount</TableCell>
                    <TableCell>Profit Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {productWiseProfit.map((prod) => (
                    <TableRow>
                      <TableCell style={{ width: '20%' }}>{prod.prod_name}</TableCell>
                      <TableCell>{prod.prod_code}</TableCell>
                      <TableCell>{prod.prod_sold_qty}</TableCell>
                      <TableCell>{format(parseFloat(prod.prod_sold_amount).toFixed(2))}</TableCell>
                      <TableCell>{format(parseFloat(prod.prod_purchased_amount).toFixed(2))}</TableCell>
                      <TableCell style={{ textAlign: 'right' }}>{format(parseFloat(prod.prod_profit_amount).toFixed(2))}</TableCell>
                    </TableRow>
                  ))}

                  <TableRow style={{ background: '#eaeaea' }}>
                    <TableCell colSpan={2} style={{ textAlign: 'right' }}>Total : </TableCell>
                    <TableCell>{productWiseProfit.reduce((prev, curr) => { return prev + parseFloat(curr.prod_sold_qty) }, 0)}</TableCell>
                    <TableCell>{format(productWiseProfit.reduce((prev, curr) => { return prev + parseFloat(curr.prod_sold_amount) }, 0).toFixed(2))}</TableCell>
                    <TableCell>{format(productWiseProfit.reduce((prev, curr) => { return prev + parseFloat(curr.prod_purchased_amount) }, 0).toFixed(2))}</TableCell>
                    <TableCell style={{ textAlign: 'right' }}>{format(parseFloat(productProfit).toFixed(2))}</TableCell>
                  </TableRow>





                  <TableRow  >
                    <TableCell colSpan={5} align="right">Received from Cash Transaction (+)</TableCell>

                    <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.cashTranProfit).toFixed(2)) : 0}</TableCell>
                  </TableRow>


                  <TableRow  >
                    <TableCell colSpan={5} align="right">Income from Services (+)</TableCell>

                    <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.serviceIncomeAmount).toFixed(2)) : 0}</TableCell>
                  </TableRow>


                  <TableRow>

                    <TableCell colSpan={5} align="right">Expense for Services Item (-)</TableCell>
                    <TableCell align="right"> {othersReport != null ? format(parseFloat(othersReport.serviceExpenseAmount).toFixed(2)) : 0}</TableCell>
                  </TableRow>




                  <TableRow>

                    <TableCell colSpan={5} align="right">Sales Return (-)</TableCell>
                    <TableCell align="right"> {othersReport != null ? format(parseFloat(othersReport.salesReturnAmount).toFixed(2)) : 0}</TableCell>
                  </TableRow>

                  <TableRow  >

                    <TableCell colSpan={5} align="right">Sales Discount (-) </TableCell>
                    <TableCell align="right">{format(parseFloat(totalSaleDiscount).toFixed(2))}</TableCell>

                  </TableRow>
                  <TableRow  >

                    <TableCell colSpan={5} align="right">Product Total Damage (-) </TableCell>
                    <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.productDamageAmount).toFixed(2)) : 0}</TableCell>



                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={5} align="right">Material Total Damage (-) </TableCell>
                    <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.materialDamageAmount).toFixed(2)) : 0}</TableCell>
                  </TableRow>
                  <TableRow  >
                    <TableCell colSpan={5} align="right">Expense (-) </TableCell>
                    <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.cashTranLoss).toFixed(2)) : 0}</TableCell>


                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={5} align="right">Employee Payment (-) </TableCell>
                    <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.employeeSalaryPay).toFixed(2)) : 0}</TableCell>

                  </TableRow>
                  <TableRow  >


                    <TableCell colSpan={5} align="right">Total Profit / Loss   </TableCell>
                    <TableCell align="right">{othersReport != null ? format(parseFloat((productProfit + parseFloat(othersReport.cashTranProfit) + parseFloat(othersReport.serviceIncomeAmount)) -
                      parseFloat(othersReport.productDamageAmount + parseFloat(othersReport.cashTranLoss) +
                        parseFloat(othersReport.employeeSalaryPay) + parseFloat(totalSaleDiscount) + parseFloat(othersReport.salesReturnAmount) + parseFloat(othersReport.materialDamageAmount) + parseFloat(othersReport.serviceExpenseAmount))).toFixed(2)) : 0}</TableCell>

                  </TableRow>


                </TableBody>
              </Table>
            </TableContainer>
          </Paper>

        </>)
      }
    </div>)
  })

  if (isCalculatorPage) {
    return renderCalculatorPage();
  }

  return (
    <div className={classes.root}>
      <NetworkLoaderOverlay visible={reportLoading} message="Loading report..." />
      <Paper className={classes.paper} style={{ marginTop: '-25px', marginBottom: '5px' }}>
        <h4 style={{
          textAlign: 'left', margin: 0, padding: 0, marginTop: '-10px',
          marginBottom: '2px'
        }}>Profit Loss Report</h4>



        <Grid container spacing={3} >



          <Grid item xs={12} sm={2} >
            <Select
              value={selectedType}
              onChange={(type) => {
                if (type == null) {
                  return false;
                }
                selectedTypeSet(type);
                selectedCustomerSet(null)
                selectedProductSet(null)
              }}
              options={types}

            />
          </Grid>

          {
            selectedType != null && selectedType.value == 'customer' ? (
              <Grid item xs={12} sm={2} >
                <Autocomplete
                  size="small"

                  autoHighlight
                  openOnFocus={true}
                  style={{ width: '100%', height: '20px' }}
                  options={customers}
                  value={selectedCustomer}
                  getOptionLabel={(option) => option.customer_name}
                  onChange={(event, selectedObj) => {
                    selectedCustomerSet(selectedObj)
                  }}
                  inputRef={customerRef}

                  onKeyDown={event => {
                    if (event.key === "Enter") {
                      fromDateRef.current.focus()
                    }
                  }}

                  renderInput={(params) => <TextField

                    {...params}
                    label="Customer "
                    variant="outlined"
                  />}
                />
              </Grid>
            ) : ''
          }




          {
            selectedType != null && selectedType.value == 'product' || selectedType.value == 'product_summary' ? (

              <Grid xs={12} sm={2} >

                <Autocomplete
                  openOnFocus={true}
                  autoHighlight={true}
                  style={{ width: '100%', height: '20px', marginTop: '10px' }}
                  options={products}
                  value={selectedProduct}
                  loading={true}
                  size="small"
                  getOptionLabel={(option) => `${option?.prod_code || ""} ${option?.prod_name || ""}`.trim()}
                  onChange={(e, product) => {
                    selectedProductSet(product)
                  }}
                  renderInput={(params) => <TextField

                    {...params}
                    label="choose a product"
                    variant="outlined"

                  />}

                />
              </Grid>


            ) : ''
          }


          <Grid item xs={12} sm={2} style={{ marginBottom: '-9px' }} >
            <MuiPickersUtilsProvider utils={DateFnsUtils} >

              <KeyboardDatePicker
                //  inputRef={saleDateRef}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    //supplierRef.current.focus()
                  }
                }}
                style={{ width: '100%', marginTop: '' }}
                value={byDateTime.fromDate}
                onChange={(datet) => {
                  byDateTimeSet({ ...byDateTime, fromDate: datet })
                }}
                label="From Date"
                format="yyyy/MM/dd"
              />
            </MuiPickersUtilsProvider>
          </Grid>


          <Grid item xs={12} sm={2} style={{ marginBottom: '-9px' }} >
            <MuiPickersUtilsProvider utils={DateFnsUtils} >

              <KeyboardDatePicker
                //inputRef={saleDateRef}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    // supplierRef.current.focus()
                  }
                }}
                style={{ width: '100%', marginTop: '' }}
                value={byDateTime.toDate}
                onChange={(datet) => {
                  byDateTimeSet({ ...byDateTime, toDate: datet })

                }}
                label="To Date"
                format="yyyy/MM/dd"
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} sm={1} >
            <Button style={{ marginTop: '5px', marginLeft: 'auto', fontSize: '14px' }}
              variant="contained"
              color="primary"
              className={classes.button}
              startIcon={<SearchIcon />}
              onClick={getSearchResult}
              disabled={reportLoading ? true : false}
            >
              Search
            </Button>
          </Grid>

        </Grid>
      </Paper>

      {
        print ? (
          <Grid container >
            <Grid item xs={12} sm={12} >
              <Paper style={{ borderRadius: '0px', marginTop: '-7px' }}>
                <ReactToPrint
                  trigger={() => <PrintIcon style={{ cursor: 'pointer', marginLeft: '30px', marginTop: '3px', marginBottom: '-8px' }} />}
                  content={() => reportRef.current}
                />
              </Paper>

            </Grid>
          </Grid>
        ) : ''
      }

      <ReportDom ref={reportRef} />

    </div>

  )
}
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  inputField: {
    width: '100%',
    marginTop: '5px'
  },
  plusLinkDiv: {
    position: 'relative'
  },
  plusLink: {
    margin: 0,
    padding: 0,
    marginTop: '-21px',
    fontSize: '29px',
    height: '21px',
    textAlign: 'right',
    position: 'absolute',
    right: 0,
    color: '#3e8d54'
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));


const mapStateToPops = (state) => {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer
  }
}
export default connect(mapStateToPops, { currentRouteSet })(CustomerTransactionHistory);
